var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "van-popup",
        {
          staticClass: "cu-popup",
          style: _vm.styleObj,
          attrs: { overlay: "", round: "", position: "bottom" },
          model: {
            value: _vm.isShowPopup,
            callback: function($$v) {
              _vm.isShowPopup = $$v
            },
            expression: "isShowPopup"
          }
        },
        [
          _c(
            "div",
            { staticClass: "popup-title" },
            [
              _vm._v("\n            " + _vm._s(_vm.title) + "\n            "),
              _c("van-icon", {
                attrs: { name: "cross" },
                on: {
                  click: function($event) {
                    _vm.isShowPopup = false
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "popup-content" }, [_vm._t("content")], 2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "popup-btn-wrap" },
            [
              _vm._t("btns", function() {
                return [
                  _c(
                    "van-button",
                    {
                      attrs: { round: "" },
                      on: {
                        click: function($event) {
                          return _vm.confirm()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnText))]
                  )
                ]
              })
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e06307e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e06307e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/InscriptionArea/compontents/cuPopup.vue
// module id = PNJP
// module chunks = 0